<template>
  <main class="type-selection" id="mainContent">
    <Stepper :step="1" />
    <div class="app-main-content">
      <h1>Select the type of reservation</h1>
      <div class="app-content-panels">
        <form class="app-panel-left">
          <TypeSubOptions v-model="subOption" :config="config" :sub-step="subStep" />
          <BaseButtonGroup>
            <button type="button" @click="handlePrev">{{ language.btnPrev }}</button>
            <button v-if="subStep === 2" type="button" class="app-btn-primary" @click="continueToSlot">
              I still need help - Continue to make a Reservation
            </button>
            <button v-else type="button" class="app-btn-primary" :class="{ disabled: subOption === null }"
                    :aria-disabled="subOption === null" @click="handleNext">
              {{ language.btnNext }}
            </button>
          </BaseButtonGroup>
        </form>
        <AsideForType />
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Stepper from '@/components/reservation/Stepper.vue';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue';
import TypeSubOptions from '@/components/reservation/type/TypeSubOptions.vue';
import VISIT_TYPE_SUB_OPTIONS from '@/assets/data/_visitTypeSubOptions';
import AsideForType from '@/components/reservation/aside/AsideForType.vue'

const store = useStore();
const router = useRouter();
const language = computed(() => store.state.user.LANG);
const PAGES = computed(() => store.state.user.PAGES);

const subStep = ref(1);
const subOption = ref(null);
const config = computed(() => VISIT_TYPE_SUB_OPTIONS[store.state.user.resType]);

onBeforeMount(() => {
  if (!config.value) {
    router.push({ name: PAGES.value.selectType }); // no sub-options for the current type — nothing to do here
    return;
  }
  const storedSubStep = store.state.user.resSubStep > 0 ? store.state.user.resSubStep : 1;
  const storedSubOption = store.state.user.resSubOption ?? null;

  // only trust restored state if it's a real option for this specific type's config
  const isValidOption = storedSubOption !== null && config.value.options.some(o => o.id === storedSubOption);
  subStep.value = isValidOption ? storedSubStep : 1;
  subOption.value = isValidOption ? storedSubOption : null;
});

const persist = () => {
  store.dispatch('user/setStoreProperty', { property: 'resSubStep', value: subStep.value });
  store.dispatch('user/setStoreProperty', { property: 'resSubOption', value: subOption.value });
};

const handlePrev = () => {
  if (subStep.value === 2) {
    subStep.value = 1;
    persist();
    return;
  }
  router.push({ name: PAGES.value.selectType });
};

const handleNext = () => {
  if (subOption.value === null) return;
  const chosen = config.value.options.find(o => o.id === subOption.value);
  persist();
  if (chosen?.routesToSlotSelection) {
    router.push({ name: PAGES.value.selectSlot });
  } else {
    subStep.value = 2;
    persist();
  }
};

const continueToSlot = () => router.push({ name: PAGES.value.selectSlot });
</script>

<style lang="scss" scoped>

.app-content-panels {
  display: flex;
  gap: 1em;
  .app-panel-left {
    flex: 1;
  }
}
.app-button-group {
  button {
    margin-bottom: 1.125em;
    &:not(:last-child) {
      margin-right: 1em;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
}

</style>